import React from "react";
import { default as WAppBar } from "@mui/material/AppBar";

function AppBar(props) {
  return <WAppBar {...props} />;
}

export default AppBar;